import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import Attention from "../ReusableComponents/Attention";
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";
import TextReadMore from "../ReusableComponents/TextReadMore";
import moment from "moment";
import { URL } from "../../variables";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/AppActions";
import { CircularProgress } from "@material-ui/core";
import Request from "../../Request";

const ModalCorretoresCsv = props => {
    const token = useSelector(store => store.AppReducer.token);
    const { processo_name, showModal, setShowModal, processo_id, onFinish } = props;
    const [corretores_csv, setcorretoresCsv] = useState({});
    const [jobs, setJobs] = useState([]);
    const [loading_jobs, setLoadingJobs] = useState(true);

    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });

    const [csvFile, setCsvFile] = useState(null);
    const [csvValue, setCsvValue] = useState('');

    const [msgErro, setMessageErro] = useState('');
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);


    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };


    useEffect(() => {

        if (showModal == true) {
            setLoadingJobs(true);
            setJobs([]);
            GetJobsCsvs();
        }
    }, [showModal]);

    const GetJobsCsvs = async (page = 1, search = '') => {

        let response = await Request.Get(`faculdade/get_csv_jobs_corretores/${processo_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }


        if (response.pagination.current_page == page && response.corretores) {

            setJobs(response.corretores);

            setPagination(response.pagination);
            setLoadingJobs(false);


        }
    }


    const addUsers = (corretores_csv,) => {
        setLoading(true);
        setMessageErro('');
        fetch(`${URL}api/faculdade/save_corretores_csv`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                processo_id: processo_id,
                corretores: Object.values(corretores_csv)
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');

                    dispatch(logout());
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    setMessageErro(erro);
                    setLoading(false);



                }
                else {
                    setLoading(false);
                    // setShowModal(false);
                    setcorretoresCsv([]);
                    setCsvFile(null);
                    GetJobsCsvs();

                    // if (resp.processo != null) {


                }




            } catch (err) {
                setLoading(false);

                setMessageErro('Erro ao pegar resposta no servidor');

                console.log(err);


            }

        })
            .catch((err) => {
                setLoading(false);
                setMessageErro('Erro ao pegar resposta no servidor. Você está conectado a internet?');

                console.log(err);
            });
    }


    return (
        <Modal
            show={showModal == true}
            dialogClassName="modal-90w modal-width"
            onHide={() => {
                setShowModal(false);
                setcorretoresCsv([]);
                setCsvFile(null);
                onFinish();

            }}
        >
            <Modal.Header closeButton closeLabel=''><Modal.Title>Adicionar corretores no processo {processo_name}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                {msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                    <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setMessageErro('')}></button>


                        <p style={{ marginBottom: 0 }}>{msgErro}</p>

                    </div>
                    <br />

                </div>}

                <div className="table-rep-plugin w-100">
                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                        <table id="tech-companies-1" className="table table-striped">
                            <thead>
                                <tr>

                                    <th>Status</th>
                                    <th>Erro</th>
                                    <th>Progresso</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading_jobs == false && jobs.map((item, id) => (

                                    <tr key={id}>
                                        <td style={{ color: (item.status == 'Erro na execução' ? 'red' : (item.status == 'Finalizado' ? 'green' : 'darkgoldenrod')) }}>{item.status}</td>
                                        <td>{item.error_friendly ?? '-'}</td>
                                        <td>{item.progresso}</td>
                                        <td>{item.total_progresso}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                        {loading_jobs == true &&
                            <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                <CircularProgress />
                            </div></div>

                        }
                    </div>
                </div>
                {loading_jobs == false && jobs.length == 0 && <div className="row w-100">
                    <div className="col-12">
                        <p style={{ textAlign: 'center' }}>Nenhuma execução encontrada</p>

                    </div>
                </div>}
                <InputGroup>

                    <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label >Arquivo .csv <Attention /> </Form.Label>
                        <input type="file" placeholder="Arquivo .csv contendo os dados dos corretores"
                            accept=".csv"
                            value={csvValue}
                            className="form form-control"
                            onChange={(e) => {

                                console.log(e.target.files[0])
                                setCsvFile(e.target.files[0]);
                                setCsvValue('');
                                setMessageErro('');


                                var reader = new FileReader();
                                reader.onload = () => {
                                    // document.getElementById('out').innerHTML = reader.result;
                                    let lines = reader.result.split("\n");
                                    let corretores = {};
                                    let cpfs = [];
                                    let emails = [];
                                    let numeros_inscricao = [];
                                    for (let i = 0; i < lines.length; i++) {
                                        let line = lines[i];
                                        line = line.split(';');
                                        let corretor = {};
                                        console.log(line)
                                        //Nome;E-mail;Senha;Salas
                                        if (line.length == 1) {
                                            continue;
                                        }
                                        if (line.length < 4) {
                                            setCsvFile(null);
                                            setCsvValue('');
                                            setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' não possui 4 colunas.')
                                            return;
                                        }
                                        if (line[0] == '' || line[1] == '' || line[2] == '' || (line[3] == '' && line[5] == '')) {
                                            setCsvFile(null);
                                            setCsvValue('');
                                            setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui colunas em branco.');
                                            return;
                                        }
                                        if (!line[3]) {
                                            line[3] = '';
                                        }
                                        
                                        if (!line[4]) {
                                            line[4] = '';
                                        }
                                        if (!line[5]) {
                                            line[5] = '';
                                        }

                                        if (!validateEmail(line[1])) {
                                            setCsvFile(null);
                                            setCsvValue('');
                                            setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um e-mail inválido.');
                                            return;
                                        }
                                        let cpfs_candidatos = []
                                        let questoes = [];

                                        if (line[3].trim().length != 0) {
                                            line[3] = line[3].replace(/ /g, '')
                                            let cpfs_ = [line[3]];
                                            for (let j = 0; j < cpfs_.length; j++) {
                                                let cpf = '';
                                                if (cpfs_[j].replace(/\./g, '').replace(/\-/g, '').length > 11) {
                                                    setCsvFile(null);
                                                    setCsvValue('');
                                                    setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' está com o CPF inválido.');


                                                    return;
                                                }

                                                let cpf_ = cpfs_[j].replace(/\./g, '').replace(/\-/g, '');
                                                for (let k = cpf_.length; k < 11; k++) {
                                                    cpf += '0';
                                                }
                                                cpf += cpfs_[j].replace(/\./g, '').replace(/\-/g, '');
                                                let formated_cpf = '';
                                                for (let k = 0; k < cpf.length; k++) {
                                                    if (k == 3) {
                                                        formated_cpf += '.';
                                                    } else if (k == 6) {
                                                        formated_cpf += '.';
                                                    } else if (k == 9) {
                                                        formated_cpf += '-';
                                                    }
                                                    formated_cpf += cpf[k];
                                                }
                                                line[4]=parseInt(line[4].replace(/ /g, ''))
                                                if(isNaN(line[4])){
                                                    setCsvFile(null);
                                                    setCsvValue('');
                                                    setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' está com um número de questão inválido.');
                                                    return;
                                                }



                                                cpfs_candidatos = [formated_cpf];
                                                questoes=[line[4]];
                                            }


                                        }


                                        // if (corretores[line[1]]) {
                                        //     setCsvFile(null);
                                        //     setCsvValue('');
                                        //     setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um e-mail que já apareceu nessa planilha. O E-mail deve ser único por corretor.');
                                        //     return;
                                        // }


                                        if (!validateEmail(line[1])) {
                                            setCsvFile(null);
                                            setCsvValue('');
                                            setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um e-mail inválido.');
                                            return;
                                        }


                                        let salas = line[5].split(',');
                                        let salas_oficial = [];
                                        if (line[5].trim().length > 0) {
                                            line[5] = line[5].replace(/ /g, '')
                                            salas = line[5].split(',');

                                            for (let iS = 0; iS < salas.length; iS++) {
                                                if (salas[iS] != '' && isNaN(parseInt(salas[iS]))) {
                                                    setCsvFile(null);
                                                    setCsvValue('');
                                                    setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um número de sala que não é um número. As salas devem ser específicadas entre \',\' (Ex: 1,2,3) ');
                                                    return;
                                                }
                                                else if (salas[iS] != '') {
                                                    salas_oficial.push(parseInt(salas[iS]))
                                                }
                                            }

                                            if (salas_oficial.length == 0) {
                                                setCsvFile(null);
                                                setCsvValue('');
                                                setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um número de sala que não é um número. As salas devem ser específicadas entre \',\' (Ex: 1,2,3) ');
                                                return;
                                            }
                                        }


                                        if (salas_oficial.length == 0 && cpfs_candidatos.length == 0) {
                                            setCsvFile(null);
                                            setCsvValue('');
                                            setMessageErro('O arquivo .csv está com o padrão inválido. O corretor da linha ' + (i + 1) + ' deve ser vinculado ou uma ou mais salas, ou a um candidato.');
                                            return;
                                        }




                                        if (corretores[line[1]] == undefined) {
                                            
                                            corretor.name = line[0];


                                            corretor.email = line[1];

                                            corretor.password = line[2];

                                            corretor.tipo = line[3];

                                            corretor.salas = salas_oficial;
                                            corretor.candidatos = [];
                                            corretor.questoes=[];
                                            if (cpfs_candidatos.length != 0) {
                                                if (cpfs.includes(cpfs_candidatos[0]+'_'+questoes[0])) {
                                                    setCsvFile(null);
                                                    setCsvValue('');
                                                    setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um CPF de candidato e questão que já apareceu nessa planilha em outro corretor. Deve ter apenas um corretor por candidato.');
                                                    return;
                                                }
                                                corretor.candidatos.push(...cpfs_candidatos)
                                                corretor.questoes.push(...questoes)
                                                cpfs.push(cpfs_candidatos[0]+'_'+questoes[0])


                                            }
                                            corretores[line[1]] = corretor;
                                        }
                                        else {
                                            
                                            corretores[line[1]].salas.push(...salas_oficial)
                                            if (cpfs_candidatos.length != 0) {
                                                if (cpfs.includes(cpfs_candidatos[0]+'_'+questoes[0])) {
                                                    setCsvFile(null);
                                                    setCsvValue('');
                                                    setMessageErro('O arquivo .csv está com o padrão inválido. A linha ' + (i + 1) + ' possui um CPF de candidato e questão que já apareceu nessa planilha em outro corretor. Deve ter apenas um corretor por candidato.');
                                                    return;
                                                }
                                                corretores[line[1]].candidatos.push(...cpfs_candidatos)
                                                corretores[line[1]].questoes.push(...questoes)
                                                cpfs.push(cpfs_candidatos[0]+'_'+questoes[0])

                                            }

                                        }



                                    }

                                    setcorretoresCsv(corretores);
                                    console.log(corretores)
                                };
                                reader.readAsBinaryString(e.target.files[0]);
                            }} />

                    </div>




                </InputGroup>
                <div>
                    <b style={{ float: "left", marginRight: "2px" }}>Padrão:  </b>
                    <div >
                        O .csv não deve ter cabeçalho (Nome das colunas). As colunas devem ser separadas por “;” no seguinte formato:
                        <br />
                        <p style={{ marginBottom: 5, fontWeight: 800, textAlign: 'center' }}>Nome; E-mail; Senha;CPF Candidato (Opcional);Número da Questão (Opcional); Salas (Opcional) </p>

                        Para o corretor, deve ser específicado um ou mais candidatos juntamento com o número da questão para correção da prova dissertativa, ou uma ou mais salas para correção de redação. As salas devem ser específicadas entre ',' , ou seja, se quiser que um corretor fique nas salas 1, 2 e 3, deve passar: 1,2,3
                        {/* {(readmore ? props.children : props.children.substring(0, props.limit) + (props.children.length > props.limit ? "..." : ""))} */}
                    </div>
                </div>
                <br />
                <br />



                <div className="flex fdcolumn flex1 margin-bottom">
                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>E-mail</th>
                                        <th>Senha</th>
                                        <th>Cpf Candidato</th>
                                        <th>Questão</th>
                                        <th>Salas</th>
                                        <th data-priority="3">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.values(corretores_csv).map((item, id) => (
                                        <tr key={id}>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td>{item.password}</td>
                                            <td style={{ whiteSpace: 'pre-line' }}>{item.candidatos.join('\n')}</td>
                                            <td style={{ whiteSpace: 'pre-line' }}>{item.questoes.join('\n')}</td>

                                            <td>{item.salas.join(',')}</td>

                                            <td>
                                                <span
                                                    onClick={(e) => {
                                                        let corretores_csv_ = { ...corretores_csv };
                                                        delete corretores_csv_[item.email]
                                                        setcorretoresCsv(corretores_csv_);
                                                    }}
                                                    className="inline-flex align-center jcc bg-danger icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Deletar corretor"
                                                >
                                                    <MdDelete size={17} color="white" />
                                                </span>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {Object.values(corretores_csv).length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum corretor adicionado</p>

                        </div>
                    </div>}
                </div>



                {loading == false && <div className="w100 inline-flex jcsb margin-top-1">
                    {/* <Link to={`/accounts/list`}>
                                    <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                                </Link> */}
                    <DefaultButton
                        bg="secondary"
                        text="Fechar"
                        icon={<RiCloseFill />}
                        onClick={() => {
                            setShowModal(false);
                            setcorretoresCsv([]);
                            setCsvFile(null);
                            onFinish();

                        }}
                    />
                    {/* <Button variant="success" type="submit" disabled={this.loading}>
                                    {this.state.loading ? <Spinner /> : ""}
                                    Registrar usuário
                                </Button> */}
                    <DefaultButton
                        type="button"
                        disabled={Object.values(corretores_csv).length == 0}

                        onClick={() => {
                            addUsers(corretores_csv);
                        }}
                        bg={Object.values(corretores_csv).length > 0 ? "confirm" : "secondary"}
                        text="Adicionar"
                    />
                </div>}

                {loading == true && <div className="w100 inline-flex jcsb margin-top-1 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                </div>}

            </Modal.Body>
        </Modal>

    );
}

export default ModalCorretoresCsv;